/**
 * Fonction pour récupérer le handle du produit vidéo
 * @returns {string} Le handle du produit vidéo
 */
function getVideoProductHandle() {
  // Chercher le handle dans le data attribute du bloc ou du lien
  const elementWithHandle = document.querySelector('[data-video-product-handle]');
  if (elementWithHandle) {
    const handle = elementWithHandle.getAttribute('data-video-product-handle');
    if (handle) {
      return handle;
    }
  }
  
  // Fallback: le handle par défaut si rien n'est trouvé
  return 'video-de-fabrication';
}

/**
 * Fonction pour ajouter la vidéo de fabrication au panier
 * @param {number|string} quantity - Quantité à ajouter
 * @param {string} productTitle - Titre du produit principal
 * @returns {Promise<any>} Promise qui se résout quand la vidéo est ajoutée
 */
function addVideoToCart(quantity, productTitle) {
  const quantityNum = typeof quantity === 'string' ? parseInt(quantity, 10) : quantity;
  const videoProductHandle = getVideoProductHandle();
  
  return fetch(`/products/${videoProductHandle}.js`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Produit vidéo non trouvé avec le handle "${videoProductHandle}". Vérifiez que le handle est correct dans les paramètres du bloc "Video fabrication".`);
      }
      return response.json();
    })
    .then(videoProduct => {
      if (!videoProduct.variants || videoProduct.variants.length === 0) {
        throw new Error('Aucune variante disponible pour le produit vidéo');
      }
      
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: videoProduct.variants[0].id,
          quantity: quantityNum || 1,
          properties: {
            '_Vidéo de fabrication': productTitle
          }
        })
      });
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Erreur lors de l\'ajout au panier');
      }
      return response.json();
    });
}

document.addEventListener('DOMContentLoaded', function() {
  // Gestion de la checkbox dans le formulaire d'ajout au panier
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const videoCheckbox = document.getElementById('add-video-checkbox');
      
      // Si la checkbox existe et est cochée, ajouter le produit vidéo
      if (videoCheckbox && videoCheckbox instanceof HTMLInputElement && videoCheckbox.checked) {
        const formData = new FormData(this);
        const quantityValue = formData.get('quantity');
        const quantity = typeof quantityValue === 'string' ? quantityValue : '1';
        
        // Récupérer le titre du produit principal pour la propriété
        const productTitle = document.querySelector('.product-title, h1')?.textContent.trim() || 'Vidéo de fabrication';
        
        // Ajouter le produit vidéo en parallèle (sans bloquer le formulaire principal)
        addVideoToCart(quantity, productTitle).catch(error => {
          console.error('Erreur ajout vidéo:', error);
        });
      }
      // Le formulaire continue son comportement normal (ajout du produit principal)
    });
  });

  // Gestion du lien d'upsell vidéo
  const videoUpsellLink = document.querySelector('[data-video-upsell-link]');
  
  if (videoUpsellLink) {
    videoUpsellLink.addEventListener('click', function(e) {
      e.preventDefault();
      
      const link = this;
      const textElement = link.querySelector('.c-video-upsell__text');
      const originalText = textElement?.textContent || 'Ajouter la vidéo de fabrication';
      
      // Désactiver le lien pendant le traitement
      link.style.pointerEvents = 'none';
      if (textElement) {
        textElement.textContent = 'Ajout en cours...';
      }
      
      // Récupérer le titre du produit principal
      const productTitle = document.querySelector('.product-title, h1')?.textContent.trim() || 'Vidéo de fabrication';
      
      // Récupérer la quantité du produit principal si disponible
      const quantityInput = document.querySelector('input[name="quantity"]');
      const quantity = quantityInput && quantityInput instanceof HTMLInputElement 
        ? parseInt(quantityInput.value) || 1 
        : 1;
      
      // Ajouter le produit vidéo au panier
      addVideoToCart(quantity, productTitle)
        .then(() => {
          // Recharger la page après l'ajout réussi
          window.location.reload();
        })
        .catch(error => {
          console.error('Erreur ajout vidéo:', error);
          if (textElement) {
            textElement.textContent = 'Erreur, réessayez';
          }
          link.style.pointerEvents = '';
          
          setTimeout(() => {
            if (textElement) {
              textElement.textContent = originalText;
            }
          }, 2000);
        });
    });
  }
});
